<script lang="ts">
import { computed, defineComponent, h, inject, unref } from 'vue';

import { omit } from '@components/utils';
import { useProxyModel, useRender } from '@components/composable';

import { CdsSlideView } from '../CdsSlideView';
import { makeSlideViewProps } from '../CdsSlideView/props';

import { CdsTabsV2Symbol } from './shared';

const makeTabsViewProps = {
  ...omit(makeSlideViewProps(), ['continuous', 'nextIcon', 'prevIcon', 'showArrows', 'touch', 'required'])
};

export const componentName = 'CdsTabsView';
export default defineComponent({
  name: componentName,
  props: makeTabsViewProps,
  emits: {
    'update:modelValue': (v: unknown) => true
  },
  setup(props, { slots }) {
    const group = inject(CdsTabsV2Symbol, null);
    const _model = useProxyModel(props, 'modelValue');

    const model = computed({
      get() {
        if (unref(_model) !== null || !group) return unref(_model);
        return unref(group.items).find((item) => unref(group.selected).includes(item.id))?.value;
      },
      set(value) {
        _model.value = value;
      }
    });

    useRender(() => {
      return h(
        CdsSlideView,
        {
          ...props,
          showArrows: false,
          required: false,
          touch: false,
          class: 'cds-tabs-view',
          modelValue: unref(model),
          'onUpdate:modelValue': (v: unknown) => (model.value = v)
        },
        slots
      );
    });

    return {};
  }
});
</script>
